module.exports = __webpack_public_path__ + "img/gp_pro.53dcc8e7.png";